// extracted by mini-css-extract-plugin
module.exports = {"scoped-class":"styles-module__scoped-class___rSz2g"};